import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { toast } from "react-toastify";
import api from "../services/api";
import Navbar from "../components/Navbar";
import QRMM from "../assets/qr momo.jpg";

const CheckoutPage = () => {
  const navigate = useNavigate();
  const { cart, clearCart } = useContext(CartContext);
  const [loading, setLoading] = useState(false);

  const [customerInfo, setCustomerInfo] = useState({
    customerName: "",
    customerEmail: "",
    customerPhone: "",
    address: "",
    note: "",
  });

  const [paymentMethod, setPaymentMethod] = useState("COD");

  // Voucher states
  const [vouchers, setVouchers] = useState([]);
  const [voucherCode, setVoucherCode] = useState("");
  const [appliedVoucher, setAppliedVoucher] = useState(null);
  const [giftVoucherCode, setGiftVoucherCode] = useState("");
  const [appliedGiftVoucher, setAppliedGiftVoucher] = useState(null);

  // Dynamic Payment Configs
  const [momoConfig, setMomoConfig] = useState({
    phone: "0898401797",
    accountHolder: "DINH QUANG TRUONG",
  });
  const [bankingConfig, setBankingConfig] = useState({
    bankName: "Techcombank",
    accountNumber: "19071924804012",
    accountHolder: "DINH QUANG TRUONG",
    bin: "970407",
  });

  useEffect(() => {
    fetchPaymentConfigs();
  }, []);

  const fetchPaymentConfigs = async () => {
    try {
      const [momoRes, bankingRes] = await Promise.all([
        api.get("/settings/payment_momo_config"),
        api.get("/settings/payment_banking_config"),
      ]);
      if (momoRes.data && momoRes.data.phone) setMomoConfig(momoRes.data);
      if (bankingRes.data && bankingRes.data.accountNumber)
        setBankingConfig(bankingRes.data);
    } catch (error) {
      console.error("Error fetching payment configs:", error);
    }
  };
  const [discountAmount, setDiscountAmount] = useState(0);
  const [showVoucherModal, setShowVoucherModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [createdOrderId, setCreatedOrderId] = useState(null);

  const items = cart?.items || [];
  const subtotal = items.reduce((sum, item) => sum + item.price * item.qty, 0);
  const shippingFee = subtotal >= 500000 ? 0 : 30000;

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem("token");
    if (!token || token === "undefined" || token === "null") {
      toast.info("Vui lòng đăng nhập để tiếp tục thanh toán!");
      navigate("/login?redirect=/checkout");
      return;
    }

    if (!items || items.length === 0) {
      toast.info("Giỏ hàng trống, vui lòng thêm sản phẩm!");
      navigate("/cart");
      return;
    }
    fetchUserVouchers();
  }, [items, navigate]);

  const fetchUserVouchers = async () => {
    try {
      const response = await api.get("/vouchers/user");
      setVouchers(response.data || []);
    } catch (error) {
      console.error("❌ Error fetching user vouchers:", error);
    }
  };

  const handleApplyVoucher = (codeOrVoucher) => {
    let voucher;
    if (typeof codeOrVoucher === "string") {
      voucher = vouchers.find(
        (v) => v.code.toUpperCase() === codeOrVoucher.toUpperCase(),
      );
      if (!voucher) {
        toast.error("Mã giảm giá không hợp lệ hoặc không có trong kho!");
        return;
      }
    } else {
      voucher = codeOrVoucher;
    }

    if (!voucher.isActive) {
      toast.error("Mã giảm giá này hiện không khả dụng!");
      return;
    }

    if (subtotal < voucher.minOrder) {
      toast.error(
        `Đơn hàng tối thiểu ${new Intl.NumberFormat("vi-VN").format(voucher.minOrder)}₫ để sử dụng mã này!`,
      );
      return;
    }

    if (voucher.type === "gift") {
      setAppliedGiftVoucher(voucher);
      setGiftVoucherCode(voucher._id); // We use ID for gift vouchers as requested
      toast.success(`Đã áp dụng quà tặng: ${voucher.giftName}`);
    } else {
      let discount = 0;
      if (voucher.type === "percent") {
        discount = subtotal * (voucher.value / 100);
      } else {
        discount = voucher.value;
      }

      setAppliedVoucher(voucher);
      setDiscountAmount(discount);
      setVoucherCode(voucher.code);
      toast.success(`Đã áp dụng mã: ${voucher.code}`);
    }

    setShowVoucherModal(false);
  };

  const removeVoucher = () => {
    setAppliedVoucher(null);
    setDiscountAmount(0);
    setVoucherCode("");
    toast.info("Đã gỡ mã giảm giá");
  };

  const removeGiftVoucher = () => {
    setAppliedGiftVoucher(null);
    setGiftVoucherCode("");
    toast.info("Đã gỡ quà tặng");
  };

  const finalTotal = subtotal + shippingFee - discountAmount;

  const formatPrice = (price) => {
    return new Intl.NumberFormat("vi-VN").format(price);
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;

    // Ràng buộc chỉ nhập số cho số điện thoại
    if (name === "customerPhone") {
      value = value.replace(/\D/g, "");
    }

    setCustomerInfo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!customerInfo.customerName.trim()) {
      toast.error("Vui lòng nhập họ tên!");
      return false;
    }
    if (!customerInfo.customerPhone.trim()) {
      toast.error("Vui lòng nhập số điện thoại!");
      return false;
    }
    if (!/^[0-9]{10}$/.test(customerInfo.customerPhone)) {
      toast.error("Số điện thoại không hợp lệ!");
      return false;
    }
    if (customerInfo.customerEmail.trim()) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customerInfo.customerEmail)) {
        toast.error("Email không hợp lệ!");
        return false;
      }
    }
    if (!customerInfo.address.trim()) {
      toast.error("Vui lòng nhập địa chỉ giao hàng!");
      return false;
    }
    return true;
  };

  const handlePlaceOrder = async () => {
    if (loading) return; // Prevent double clicks
    if (!validateForm()) return;

    // If Non-COD, just show modal and return
    if (paymentMethod !== "COD") {
      setShowPaymentModal(true);
      return;
    }

    setLoading(true);

    try {
      const userStr = localStorage.getItem("user");
      const user = userStr ? JSON.parse(userStr) : null;
      const userId = user?._id || "";

      const orderData = {
        userId: userId,
        customerName: customerInfo.customerName,
        customerEmail: customerInfo.customerEmail,
        customerPhone: customerInfo.customerPhone,
        address: customerInfo.address,
        note: customerInfo.note,
        items: items.map((item) => ({
          productId: item.productId,
          name: item.name,
          price: item.price,
          qty: item.qty,
          image: item.image,
          selectedColor: item.selectedColor || "Mặc định",
          selectedSize: item.selectedSize || "One Size",
        })),
        voucherCode: appliedVoucher?.code || "",
        giftVoucherCode: giftVoucherCode || "",
        discountAmount: discountAmount,
        subtotal: subtotal,
        shippingFee: shippingFee,
        total: finalTotal,
        status: "Chờ xác nhận",
        paymentMethod: paymentMethod,
      };

      const response = await api.post("/orders", orderData);

      await clearCart();

      toast.success("🎉 Đặt hàng thành công!");
      localStorage.setItem("lastOrderId", response.data._id);
      
      // We DON'T set loading(false) here to keep button disabled during navigation
      setTimeout(() => {
        navigate(`/order-success/${response.data._id}`);
      }, 1500);
      return; // Return early so finally block doesn't set loading(false)
    } catch (error) {
      console.error("❌ Error creating order:", error);
      toast.error(
        error.response?.data?.error || "Đặt hàng thất bại, vui lòng thử lại!",
      );
      setLoading(false); // Only set loading false on error
    }
  };

  const handleManualPaymentConfirm = async () => {
    if (loading) return;
    if (!validateForm()) return;
    setLoading(true);
    try {
      const userStr = localStorage.getItem("user");
      const user = userStr ? JSON.parse(userStr) : null;
      const userId = user?._id || "";

      const orderData = {
        userId: userId,
        customerName: customerInfo.customerName,
        customerEmail: customerInfo.customerEmail,
        customerPhone: customerInfo.customerPhone,
        address: customerInfo.address,
        note: customerInfo.note,
        items: items.map((item) => ({
          productId: item.productId,
          name: item.name,
          price: item.price,
          qty: item.qty,
          image: item.image,
          selectedColor: item.selectedColor || "Mặc định",
          selectedSize: item.selectedSize || "One Size",
        })),
        voucherCode: appliedVoucher?.code || "",
        giftVoucherCode: giftVoucherCode || "",
        discountAmount: discountAmount,
        subtotal: subtotal,
        shippingFee: shippingFee,
        total: finalTotal,
        status: "Chờ xác nhận",
        paymentMethod: paymentMethod,
      };

      const response = await api.post("/orders", orderData);
      const newOrderId = response.data._id;

      await clearCart();
      setShowPaymentModal(false);

      localStorage.setItem("lastOrderId", newOrderId);
      toast.success("🎉 Cảm ơn bạn! Đơn hàng đã được gửi tới Admin.");

      setTimeout(() => {
        navigate(`/order-success/${newOrderId}`);
      }, 1500);
    } catch (error) {
      console.error("❌ Error creating order after payment:", error);
      toast.error(error.response?.data?.error || "Có lỗi xảy ra, vui lòng thử lại!");
      setLoading(false);
    }
  };

  if (!cart) {
    return null;
  }

  return (
    <>
      <Navbar />
      <div 
        className="min-h-screen bg-gray-50 dark:bg-slate-950 pt-16 md:pt-40 pb-32 sm:pb-8 transition-colors duration-300"
        style={{ 
          zoom: "0.8",
          MozTransform: "scale(0.8)",
          MozTransformOrigin: "top center"
        }}
      >
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
          <div className="mb-4 sm:mb-8">
            <h1 className="text-xl sm:text-3xl font-bold text-gray-900 dark:text-white font-inter">
              Thanh toán
            </h1>
            <p className="text-xs sm:text-base text-gray-600 dark:text-gray-400 mt-1 sm:mt-2">
              Vui lòng điền đầy đủ thông tin để hoàn tất đơn hàng
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-4 sm:gap-8">
            <div className="lg:col-span-2 space-y-4 sm:space-y-6">
              <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm p-4 sm:p-6 border border-gray-100 dark:border-slate-800">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6 flex items-center gap-2 font-inter">
                  <span className="p-1.5 sm:p-2 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg material-symbols-outlined text-[20px] sm:text-[24px]">
                    person
                  </span>
                  Thông tin khách hàng
                </h2>

                <div className="grid md:grid-cols-2 gap-4 sm:gap-5">
                  <div>
                    <label className="block text-xs sm:text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1.5 sm:mb-2 ml-1">
                      Họ và tên <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="customerName"
                      value={customerInfo.customerName}
                      onChange={handleInputChange}
                      placeholder="Nguyễn Văn A"
                      className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-900 dark:text-white rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all placeholder:text-gray-400 text-sm sm:text-base"
                    />
                  </div>

                  <div>
                    <label className="block text-xs sm:text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1.5 sm:mb-2 ml-1">
                      Số điện thoại <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="customerPhone"
                      value={customerInfo.customerPhone}
                      onChange={handleInputChange}
                      placeholder="0123456789"
                      className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-900 dark:text-white rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all placeholder:text-gray-400 text-sm sm:text-base"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-xs sm:text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1.5 sm:mb-2 ml-1">
                      Email{" "}
                      <span className="text-gray-400 dark:text-gray-500 font-normal">
                        (tuỳ chọn)
                      </span>
                    </label>
                    <input
                      type="email"
                      name="customerEmail"
                      value={customerInfo.customerEmail}
                      onChange={handleInputChange}
                      placeholder="example@email.com"
                      className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-900 dark:text-white rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all placeholder:text-gray-400 text-sm sm:text-base"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-xs sm:text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1.5 sm:mb-2 ml-1">
                      Địa chỉ giao hàng <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="address"
                      value={customerInfo.address}
                      onChange={handleInputChange}
                      placeholder="Số nhà, tên đường, phường/xã, quận/huyện, tỉnh/thành phố"
                      rows="2"
                      className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-900 dark:text-white rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none placeholder:text-gray-400 text-sm sm:text-base"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-xs sm:text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1.5 sm:mb-2 ml-1">
                      Ghi chú đơn hàng (tuỳ chọn)
                    </label>
                    <textarea
                      name="note"
                      value={customerInfo.note}
                      onChange={handleInputChange}
                      placeholder="Ghi chú về đơn hàng, ví dụ: thời gian giao hàng..."
                      rows="2"
                      className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-900 dark:text-white rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none placeholder:text-gray-400 text-sm sm:text-base"
                    />
                  </div>
                </div>
              </div>

              <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm p-4 sm:p-6 border border-gray-100 dark:border-slate-800">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6 flex items-center gap-2 font-inter">
                  <span className="p-1.5 sm:p-2 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg material-symbols-outlined text-[20px] sm:text-[24px]">
                    payments
                  </span>
                  Phương thức thanh toán
                </h2>

                <div className="grid gap-2 sm:gap-3">
                  <label
                    className={`flex items-center p-3 sm:p-4 border-2 rounded-xl cursor-pointer transition-all ${paymentMethod === "COD" ? "border-blue-500 bg-blue-50/30 dark:bg-blue-900/10" : "border-gray-100 dark:border-slate-800 hover:border-blue-200 dark:hover:border-slate-700"}`}
                  >
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="COD"
                      checked={paymentMethod === "COD"}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 focus:ring-blue-500"
                    />
                    <div className="ml-3 sm:ml-4 flex items-center gap-2 sm:gap-3">
                      <div className="p-1.5 bg-white dark:bg-slate-800 rounded-lg shadow-sm text-sm sm:text-base">
                        💵
                      </div>
                      <div>
                        <p className="font-bold text-sm sm:text-base text-gray-900 dark:text-white leading-tight">
                          Thanh toán khi nhận hàng
                        </p>
                        <p className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">
                          COD - Miễn phí thu hộ
                        </p>
                      </div>
                    </div>
                  </label>

                  <label
                    className={`flex items-center p-3 sm:p-4 border-2 rounded-xl cursor-pointer transition-all ${paymentMethod === "Banking" ? "border-blue-500 bg-blue-50/30 dark:bg-blue-900/10" : "border-gray-100 dark:border-slate-800 hover:border-blue-200 dark:hover:border-slate-700"}`}
                  >
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="Banking"
                      checked={paymentMethod === "Banking"}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 focus:ring-blue-500"
                    />
                    <div className="ml-3 sm:ml-4 flex items-center gap-2 sm:gap-3">
                      <div className="p-1.5 bg-white dark:bg-slate-800 rounded-lg shadow-sm text-sm sm:text-base">
                        🏦
                      </div>
                      <div>
                        <p className="font-bold text-sm sm:text-base text-gray-900 dark:text-white leading-tight">
                          Chuyển khoản ngân hàng
                        </p>
                        <p className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">
                          Hỗ trợ QR Code nhanh chóng
                        </p>
                      </div>
                    </div>
                  </label>

                  <label
                    className={`flex items-center p-3 sm:p-4 border-2 rounded-xl cursor-pointer transition-all ${paymentMethod === "Momo" ? "border-pink-500 bg-pink-50/30 dark:bg-pink-900/10" : "border-gray-100 dark:border-slate-800 hover:border-pink-200 dark:hover:border-slate-700"}`}
                  >
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="Momo"
                      checked={paymentMethod === "Momo"}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      className="w-4 h-4 sm:w-5 sm:h-5 text-pink-600 focus:ring-pink-500"
                    />
                    <div className="ml-3 sm:ml-4 flex items-center gap-2 sm:gap-3">
                      <div className="p-1.5 bg-white dark:bg-slate-800 rounded-lg shadow-sm text-sm sm:text-base">
                        📱
                      </div>
                      <div>
                        <p className="font-bold text-sm sm:text-base text-gray-900 dark:text-white leading-tight">
                          Ví điện tử MoMo
                        </p>
                        <p className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">
                          Thanh toán tức thì
                        </p>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1 space-y-4 sm:space-y-6">
              {/* Voucher Section */}
              <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm p-4 sm:p-6 border border-gray-100 dark:border-slate-800">
                <div className="p-3 bg-yellow-50 mb-4 dark:bg-yellow-900/10 border border-yellow-100 dark:border-yellow-900/30 rounded-xl space-y-2">
                  <p className="text-[11px] sm:text-xs text-yellow-800 dark:text-yellow-400 leading-relaxed">
                    ⭐ <strong>Ưu đãi đặc biệt:</strong> Đánh giá 5 sao trên
                    <a
                      href="https://www.google.com/maps/search/?api=1&query=TAHA+SHOES+44+D.+24+Linh+Dong+Thu+Duc"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline font-bold mx-1 hover:text-yellow-600 transition-colors"
                    >
                      Google Maps
                    </a>
                    sẽ được voucher giảm <strong>50K</strong> trừ trực tiếp vào
                    đơn hàng.
                  </p>
                  <p className="text-[10px] sm:text-[11px] text-yellow-700 dark:text-yellow-500">
                    Bạn đánh giá rồi chụp màn hình gửi qua
                    <a
                      href="https://zalo.me/0765109784"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline font-bold mx-1 hover:text-yellow-600 transition-colors"
                    >
                      Zalo: 0765.109.784
                    </a>
                    giúp shop nhé, shop gửi mã ngay! 🎁
                  </p>
                </div>
                <h2 className="text-base sm:text-lg font-bold text-gray-900 dark:text-white mb-3 sm:mb-4 flex items-center gap-2">
                  <span className="material-symbols-outlined text-blue-600 dark:text-blue-400 text-[20px] sm:text-[24px]">
                    confirmation_number
                  </span>
                  Mã giảm giá
                </h2>
                <div className="space-y-3">
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={voucherCode}
                      onChange={(e) => setVoucherCode(e.target.value)}
                      placeholder="Nhập mã..."
                      className="flex-1 px-3 py-2 bg-gray-50 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-900 dark:text-white rounded-lg outline-none focus:ring-2 focus:ring-blue-500 transition-all uppercase font-bold text-xs sm:text-sm"
                    />
                    <button
                      onClick={() => handleApplyVoucher(voucherCode)}
                      disabled={!voucherCode || appliedVoucher}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg font-bold text-xs sm:text-sm hover:bg-blue-700 transition disabled:bg-gray-300 dark:disabled:bg-slate-800"
                    >
                      Dùng
                    </button>
                  </div>

                  <button
                    onClick={() => setShowVoucherModal(true)}
                    className="w-full flex items-center justify-between p-2.5 sm:p-3 border border-dashed border-blue-200 dark:border-blue-900/50 bg-blue-50/30 dark:bg-blue-900/10 rounded-lg text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition group"
                  >
                    <div className="flex items-center gap-2">
                      <span className="material-symbols-outlined text-[18px] sm:text-[20px]">
                        inventory_2
                      </span>
                      <span className="font-bold text-xs sm:text-sm">
                        Chọn từ kho voucher
                      </span>
                    </div>
                    <span className="material-symbols-outlined text-[16px] sm:text-[18px] group-hover:translate-x-1 transition-transform">
                      chevron_right
                    </span>
                  </button>

                  {appliedVoucher && (
                    <div className="mt-3 p-2.5 sm:p-3 bg-green-50 dark:bg-green-900/10 border border-green-200 dark:border-green-900/30 rounded-xl flex items-center justify-between animate-fadeIn">
                      <div className="flex items-center gap-2 sm:gap-3">
                        <span className="text-xl sm:text-2xl">🎟️</span>
                        <div>
                          <p className="text-xs sm:text-sm font-bold text-green-800 dark:text-green-400">
                            {appliedVoucher.code}
                          </p>
                          <p className="text-[9px] sm:text-[11px] text-green-600 dark:text-green-500">
                            Giảm {formatPrice(discountAmount)}₫
                          </p>
                        </div>
                      </div>
                      <button
                        onClick={removeVoucher}
                        className="p-1 hover:bg-green-100 dark:hover:bg-green-900/20 rounded-full text-green-700 dark:text-green-400"
                      >
                        <span className="material-symbols-outlined text-[16px] sm:text-[18px]">
                          close
                        </span>
                      </button>
                    </div>
                  )}

                  {appliedGiftVoucher && (
                    <div className="mt-3 p-2.5 sm:p-3 bg-blue-50 dark:bg-blue-900/10 border border-blue-200 dark:border-blue-900/30 rounded-xl flex items-center justify-between animate-fadeIn">
                      <div className="flex items-center gap-2 sm:gap-3">
                        <span className="text-xl sm:text-2xl">🎁</span>
                        <div>
                          <p className="text-xs sm:text-sm font-bold text-blue-800 dark:text-blue-400">
                            {appliedGiftVoucher.giftName}
                          </p>
                          <p className="text-[9px] sm:text-[11px] text-blue-600 dark:text-blue-500">
                            Quà tặng kèm theo
                          </p>
                        </div>
                      </div>
                      <button
                        onClick={removeGiftVoucher}
                        className="p-1 hover:bg-blue-100 dark:hover:bg-blue-900/20 rounded-full text-blue-700 dark:text-blue-400"
                      >
                        <span className="material-symbols-outlined text-[16px] sm:text-[18px]">
                          close
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm p-4 sm:p-6 lg:sticky lg:top-8 border border-gray-100 dark:border-slate-800">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6 font-inter">
                  Tóm tắt đơn hàng
                </h2>
                <div className="space-y-3 sm:space-y-4 mb-4 sm:mb-6 max-h-48 sm:max-h-60 overflow-y-auto pt-1 sm:pt-3 px-1 sm:px-2 pr-2 custom-scrollbar">
                  {items.map((item, index) => (
                    <div
                      key={`${item.productId}-${item.selectedColor}-${item.selectedSize}-${index}`}
                      className="flex gap-3 sm:gap-4 group"
                    >
                      <div className="relative flex-shrink-0">
                        <img
                          src={item.image}
                          alt={item.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://cdn-icons-png.flaticon.com/512/679/679821.png"; // Gift icon fallback
                          }}
                          className="w-12 h-12 sm:w-16 sm:h-16 object-cover rounded-xl border border-gray-100 dark:border-slate-800 group-hover:scale-105 transition-transform"
                        />
                        {(item.isGift ||
                          (item.name &&
                            item.name.toLowerCase().includes("quà tặng"))) && (
                          <div className="absolute -top-1 -left-1 bg-blue-600 text-white rounded-full p-0.5 shadow-sm z-20">
                            <span className="material-symbols-outlined text-[10px]">
                              redeem
                            </span>
                          </div>
                        )}
                        <span className="absolute -top-1 -right-1 bg-gray-800 dark:bg-slate-700 text-white text-[9px] sm:text-[11px] font-bold min-w-[18px] sm:min-w-[20px] h-[18px] sm:h-[20px] flex items-center justify-center rounded-full px-1 border-2 border-white dark:border-slate-900 shadow-sm z-10">
                          {item.qty}
                        </span>
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 dark:text-white text-xs sm:text-sm truncate">
                          {item.name}
                        </h3>
                        <p className="text-[10px] sm:text-[11px] text-gray-400 dark:text-gray-500 mt-0.5 truncate">
                          {item.selectedColor} / {item.selectedSize}
                        </p>
                        <div className="flex items-center gap-2 mt-1">
                          <p className="font-bold text-blue-600 dark:text-blue-400 text-xs sm:text-sm">
                            {formatPrice(item.price * item.qty)}₫
                          </p>
                          {item.isGift && item.originalPrice && (
                            <p className="text-[9px] sm:text-[10px] text-gray-400 line-through">
                              {formatPrice(item.originalPrice * item.qty)}₫
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Gift Item Display */}
                  {appliedGiftVoucher && (
                    <div className="flex gap-3 sm:gap-4 group border-t border-blue-50 dark:border-blue-900/20 pt-3 mt-3 animate-fadeIn">
                      <div className="relative flex-shrink-0">
                        <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-50 dark:bg-blue-900/20 rounded-xl flex items-center justify-center border border-blue-100 dark:border-blue-900/30">
                          <span className="text-2xl sm:text-3xl">🎁</span>
                        </div>
                        <span className="absolute -top-1 -right-1 bg-blue-600 text-white text-[9px] sm:text-[11px] font-bold min-w-[18px] sm:min-w-[20px] h-[18px] sm:h-[20px] flex items-center justify-center rounded-full px-1 border-2 border-white dark:border-slate-900 shadow-sm z-10">
                          1
                        </span>
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-blue-600 dark:text-blue-400 text-xs sm:text-sm truncate">
                          {appliedGiftVoucher.giftName}
                        </h3>
                        <p className="text-[10px] sm:text-[11px] text-blue-400 dark:text-blue-500 mt-0.5 font-bold uppercase tracking-widest">
                          Quà tặng miễn phí
                        </p>
                        <div className="flex items-center gap-2 mt-1">
                          <p className="font-black text-green-600 dark:text-green-400 text-xs sm:text-sm">
                            0₫
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="border-t border-dashed border-gray-100 dark:border-slate-800 pt-4 space-y-2 sm:space-y-3">
                  <div className="flex justify-between text-xs sm:text-sm text-gray-600 dark:text-gray-400 leading-none">
                    <span>Tạm tính</span>
                    <span className="font-bold text-gray-900 dark:text-white">
                      {formatPrice(subtotal)}₫
                    </span>
                  </div>

                  <div className="flex justify-between text-xs sm:text-sm text-gray-600 dark:text-gray-400 leading-none">
                    <span>Phí vận chuyển</span>
                    <span
                      className={`font-bold ${
                        shippingFee === 0
                          ? "text-green-600"
                          : "text-gray-900 dark:text-white"
                      }`}
                    >
                      {shippingFee === 0
                        ? "Miễn phí"
                        : `${formatPrice(shippingFee)}₫`}
                    </span>
                  </div>

                  {discountAmount > 0 && (
                    <div className="flex justify-between text-xs sm:text-sm text-green-600 dark:text-green-500 leading-none">
                      <span className="flex items-center gap-1">
                        <span className="material-symbols-outlined text-[14px] sm:text-[16px]">
                          local_offer
                        </span>
                        Giảm voucher
                      </span>
                      <span className="font-bold">
                        -{formatPrice(discountAmount)}₫
                      </span>
                    </div>
                  )}

                  <div className="border-t border-gray-100 dark:border-slate-800 pt-3 flex justify-between items-baseline">
                    <span className="text-base sm:text-lg font-bold text-gray-900 dark:text-white font-inter">
                      Tổng cộng
                    </span>
                    <span className="text-xl sm:text-2xl font-black text-red-600 dark:text-red-500 font-inter leading-none">
                      {formatPrice(finalTotal)}₫
                    </span>
                  </div>
                </div>

                <button
                  id="place-order-btn"
                  onClick={handlePlaceOrder}
                  disabled={loading}
                  className="hidden sm:flex w-full mt-4 sm:mt-6 bg-blue-600 text-white py-3 sm:py-4 rounded-xl font-bold text-base sm:text-lg hover:bg-blue-700 transition-all shadow-lg shadow-blue-200 dark:shadow-none hover:shadow-xl active:scale-[0.98] disabled:bg-gray-300 dark:disabled:bg-slate-800 disabled:shadow-none items-center justify-center gap-2 uppercase tracking-widest text-[11px] sm:text-sm"
                >
                  {loading ? (
                    <span className="material-symbols-outlined animate-spin text-[20px] sm:text-[24px]">
                      refresh
                    </span>
                  ) : (
                    <>
                      <span className="material-symbols-outlined text-[20px] sm:text-[24px]">
                        {paymentMethod === "COD" ? "shopping_bag" : "payments"}
                      </span>
                      {paymentMethod === "COD"
                        ? "Đặt hàng ngay"
                        : "Tiến hành thanh toán"}
                    </>
                  )}
                </button>

                <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-gray-100 dark:border-slate-800">
                  <div className="flex items-center gap-3 text-[10px] sm:text-[11px] text-gray-400 dark:text-gray-500 font-medium">
                    <span className="p-1 px-2 bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 rounded">
                      100% Secure
                    </span>
                    <span>Mọi thông tin đều được mã hóa bảo mật SSL</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sticky Mobile Place Order Button */}
        <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-slate-800 p-4 sm:hidden z-40 shadow-[0_-10px_15px_-3px_rgba(0,0,0,0.05)]">
          <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
            <div className="flex flex-col">
              <span className="text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-wider">
                Tổng cộng
              </span>
              <span className="text-lg font-black text-red-600 dark:text-red-500">
                {formatPrice(finalTotal)}₫
              </span>
            </div>
            <button
              onClick={handlePlaceOrder}
              disabled={loading}
              className="flex-1 bg-blue-600 text-white py-3 rounded-xl font-bold text-sm hover:bg-blue-700 transition-all active:scale-[0.98] disabled:bg-gray-300 dark:disabled:bg-slate-800 flex items-center justify-center gap-2 uppercase tracking-wider shadow-lg shadow-blue-200 dark:shadow-none"
            >
              {loading ? (
                <span className="material-symbols-outlined animate-spin text-[20px]">
                  refresh
                </span>
              ) : (
                <>
                  <span className="material-symbols-outlined text-[20px]">
                    {paymentMethod === "COD" ? "shopping_bag" : "payments"}
                  </span>
                  {paymentMethod === "COD" ? "Đặt hàng" : "Thanh toán"}
                </>
              )}
            </button>
          </div>
        </div>

        {/* Payment Confirmation Modal */}
        {showPaymentModal && (
          <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
            <div
              className="absolute inset-0 bg-black/60 backdrop-blur-md"
              onClick={() => setShowPaymentModal(false)}
            ></div>
            <div className="bg-white dark:bg-slate-900 rounded-[24px] w-full max-w-md overflow-hidden relative shadow-2xl animate-modalUp border border-gray-100 dark:border-slate-800">
              <div className="p-4 bg-gradient-to-r from-blue-600 to-indigo-700 text-white flex justify-between items-center">
                <div>
                  <h3 className="text-lg sm:text-xl font-bold flex items-center gap-2">
                    <span className="material-symbols-outlined">payments</span>
                    Xác nhận thanh toán
                  </h3>
                  <p className="text-blue-100 text-[10px] sm:text-xs mt-0.5">
                    Vui lòng hoàn tất giao dịch để đặt hàng
                  </p>
                </div>
                <button
                  onClick={() => setShowPaymentModal(false)}
                  className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full hover:bg-white/20 transition-all text-white"
                >
                  <span className="material-symbols-outlined text-[20px] sm:text-[24px]">
                    close
                  </span>
                </button>
              </div>

              <div className="p-4 sm:p-5 space-y-3 sm:space-y-4">
                <div className="text-center">
                  <p className="text-gray-500 dark:text-gray-400 text-[9px] sm:text-[10px] mb-0.5 uppercase tracking-wider font-bold">
                    Số tiền cần thanh toán
                  </p>
                  <h2 className="text-2xl sm:text-3xl font-black text-red-600 dark:text-red-500 font-inter tracking-tight leading-none">
                    {formatPrice(finalTotal)}₫
                  </h2>
                </div>

                {paymentMethod === "Banking" ? (
                  <div className="space-y-2 sm:space-y-3">
                    <div className="bg-blue-50/50 dark:bg-blue-900/10 p-3 sm:p-4 rounded-xl border border-blue-100 dark:border-blue-900/30 space-y-1.5 sm:space-y-2">
                      <div className="flex justify-between items-center text-[11px] sm:text-sm">
                        <span className="text-gray-500 dark:text-gray-400">
                          Ngân hàng:
                        </span>
                        <span className="font-bold text-gray-900 dark:text-white">
                          {bankingConfig.bankName}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-[11px] sm:text-sm">
                        <span className="text-gray-500 dark:text-gray-400">
                          Số tài khoản:
                        </span>
                        <div className="flex items-center gap-1.5">
                          <span className="font-black text-gray-900 dark:text-white text-xs sm:text-base">
                            {bankingConfig.accountNumber}
                          </span>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText(
                                bankingConfig.accountNumber,
                              );
                              toast.info("Đã sao chép số tài khoản");
                            }}
                            className="p-1 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30 rounded"
                          >
                            <span className="material-symbols-outlined text-[14px] sm:text-[18px]">
                              content_copy
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="flex justify-between items-center text-[11px] sm:text-sm">
                        <span className="text-gray-500 dark:text-gray-400">
                          Chủ TK:
                        </span>
                        <span className="font-bold text-gray-900 dark:text-white uppercase truncate ml-2">
                          {bankingConfig.accountHolder}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-[11px] sm:text-sm">
                        <span className="text-gray-500 dark:text-gray-400">
                          Nội dung:
                        </span>
                        <div className="flex items-center gap-1.5">
                          <span className="font-bold text-blue-600 dark:text-blue-400">
                            GS{customerInfo.customerPhone.slice(-4)}
                            {Date.now().toString().slice(-4)}
                          </span>
                          <button
                            onClick={() => {
                              const msg = `GS${customerInfo.customerPhone.slice(-4)}${Date.now().toString().slice(-4)}`;
                              navigator.clipboard.writeText(msg);
                              toast.info("Đã sao chép nội dung");
                            }}
                            className="p-1 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30 rounded"
                          >
                            <span className="material-symbols-outlined text-[14px]">
                              content_copy
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white rounded-2xl p-3 sm:p-4 flex flex-col items-center shadow-inner border border-blue-50 dark:border-blue-900/20">
                      <img
                        src={
                          `https://img.vietqr.io/image/${bankingConfig.bin}-${bankingConfig.accountNumber}-compact2.png?amount=${finalTotal}&addInfo=${encodeURIComponent(`GS ${customerInfo.customerPhone.slice(-4)} ${createdOrderId ? createdOrderId.slice(-4) : ""}`)}&accountName=${encodeURIComponent(bankingConfig.accountHolder)}`
                        }
                        alt="QR Payment"
                        className="w-40 h-40 sm:w-56 sm:h-56 rounded-lg mb-2 object-contain"
                      />
                      <div className="flex items-center gap-1.5 text-blue-600 dark:text-blue-400">
                        <span className="material-symbols-outlined text-[16px] animate-pulse">qr_code_scanner</span>
                        <p className="text-[10px] sm:text-xs font-bold uppercase tracking-tight">
                          Quét để tự động điền số tiền
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-3 sm:space-y-4">
                    <div className="bg-pink-50 dark:bg-pink-900/10 p-3 sm:p-4 rounded-xl border border-pink-100 dark:border-pink-900/30 flex flex-col items-center text-center">
                      <div className="bg-white p-2 rounded-2xl mb-3 shadow-inner border border-pink-100">
                        <img
                          src={momoConfig.qrImage || QRMM}
                          alt="Momo QR"
                          className="w-40 h-40 sm:w-56 sm:h-56 rounded-lg object-contain"
                        />
                      </div>
                      <div>
                        <p className="font-bold text-pink-600 dark:text-pink-400 text-xs sm:text-sm leading-none flex items-center justify-center gap-1">
                          <span className="material-symbols-outlined text-[16px]">
                            account_balance_wallet
                          </span>
                          Ví MoMo
                        </p>
                        <div className="flex items-center justify-center gap-1.5 mt-1">
                          <p className="text-[10px] sm:text-xs text-gray-900 dark:text-white font-bold">
                            {momoConfig.phone}
                          </p>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText(momoConfig.phone);
                              toast.info("Đã sao chép số MoMo");
                            }}
                            className="p-1 text-pink-600 hover:bg-pink-100 dark:hover:bg-pink-900/20 rounded"
                          >
                            <span className="material-symbols-outlined text-[12px] sm:text-[14px]">
                              content_copy
                            </span>
                          </button>
                        </div>
                        <p className="text-[10px] sm:text-xs font-black text-gray-900 dark:text-white uppercase mt-0.5">
                          {momoConfig.accountHolder}
                        </p>
                      </div>
                    </div>
                    <div className="p-2 sm:p-3 bg-yellow-50 dark:bg-yellow-900/10 rounded-xl border border-yellow-100 dark:border-yellow-900/30 flex gap-2">
                      <span className="material-symbols-outlined text-yellow-600 dark:text-yellow-400 text-[16px] sm:text-[18px]">
                        info
                      </span>
                      <p className="text-[9px] sm:text-[11px] text-yellow-800 dark:text-yellow-400 leading-relaxed font-medium">
                        Nhập nội dung là{" "}
                        <span className="font-bold underline italic">
                          GS{customerInfo.customerPhone.slice(-4)}
                        </span>{" "}
                        để hệ thống ghi nhận chính xác.
                      </p>
                    </div>
                  </div>
                )}

                <div className="flex flex-col gap-2 sm:gap-3 items-center pt-1 sm:pt-2">
                  <button
                    onClick={handleManualPaymentConfirm}
                    disabled={loading}
                    className="w-full py-2.5 sm:py-3 bg-blue-600 text-white rounded-xl font-bold text-sm sm:text-base hover:bg-blue-700 transition-all shadow-lg shadow-blue-200 dark:shadow-none active:scale-[0.98] disabled:bg-gray-300 dark:disabled:bg-slate-800 flex items-center justify-center gap-2"
                  >
                    {loading ? (
                      <span className="material-symbols-outlined animate-spin">
                        refresh
                      </span>
                    ) : (
                      <>
                        <span className="material-symbols-outlined text-[18px] sm:text-[20px]">
                          check_circle
                        </span>
                        Tôi đã thanh toán
                      </>
                    )}
                  </button>

                  <button
                    onClick={() => setShowPaymentModal(false)}
                    className="w-full py-2 sm:py-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-xl font-bold text-xs sm:text-sm transition-all"
                  >
                    Hủy bỏ giao dịch
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Voucher Warehouse Modal */}
        {showVoucherModal && (
          <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
            <div
              className="absolute inset-0 bg-black/40 backdrop-blur-sm"
              onClick={() => setShowVoucherModal(false)}
            ></div>
            <div className="bg-white dark:bg-slate-900 rounded-3xl w-full max-w-lg overflow-hidden relative shadow-2xl animate-modalUp border border-gray-100 dark:border-slate-800">
              <div className="p-5 sm:p-6 bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                <div className="flex items-center justify-between mb-1 sm:mb-2">
                  <h3 className="text-lg sm:text-xl font-bold flex items-center gap-2">
                    <span className="material-symbols-outlined">
                      inventory_2
                    </span>
                    Kho Voucher của bạn
                  </h3>
                  <button
                    onClick={() => setShowVoucherModal(false)}
                    className="hover:rotate-90 transition-transform"
                  >
                    <span className="material-symbols-outlined">close</span>
                  </button>
                </div>
                <p className="text-blue-100 text-[10px] sm:text-xs italic">
                  Hãy chọn 1 mã có giá trị cao nhất cho đơn này nhé!
                </p>
              </div>

              <div className="p-4 sm:p-6 max-h-[60vh] overflow-y-auto bg-gray-50 dark:bg-slate-950 space-y-3 sm:space-y-4">
                {vouchers.length === 0 ? (
                  <div className="text-center py-10 text-gray-400">
                    <span className="material-symbols-outlined text-[48px] sm:text-[64px] block mb-2 sm:mb-3 opacity-20">
                      sentiment_dissatisfied
                    </span>
                    <p className="font-bold text-sm sm:text-base">
                      Bạn chưa có voucher nào!
                    </p>
                    <p className="text-[10px] sm:text-xs">
                      Hãy tham gia vòng quay hoặc săn thêm voucher nhé.
                    </p>
                  </div>
                ) : (
                  vouchers.map((v) => {
                    const isEligible = subtotal >= v.minOrder;
                    return (
                      <div
                        key={v._id}
                        className={`relative flex items-stretch border-2 rounded-2xl overflow-hidden bg-white dark:bg-slate-900 transition-all ${
                          isEligible
                            ? appliedVoucher?._id === v._id
                              ? "border-blue-500 ring-2 ring-blue-100 dark:ring-blue-900/30"
                              : "border-transparent dark:border-slate-800 hover:border-blue-200"
                            : "opacity-60 grayscale"
                        }`}
                      >
                        <div
                          className={`w-1.5 sm:w-2 ${v.type === "gift" ? "bg-cyan-500" : v.type === "percent" ? "bg-orange-400" : "bg-blue-500"}`}
                        ></div>

                        <div className="flex-1 p-3 sm:p-4 flex items-center gap-3 sm:gap-4">
                          <div
                            className={`h-12 w-12 sm:h-16 sm:w-16 rounded-xl sm:rounded-2xl flex flex-col items-center justify-center text-white flex-shrink-0 ${v.type === "gift" ? "bg-cyan-500" : v.type === "percent" ? "bg-orange-400" : "bg-blue-500"}`}
                          >
                            <span className="text-sm sm:text-lg font-black leading-none uppercase">
                              {v.type === "gift"
                                ? "🎁"
                                : v.type === "percent"
                                  ? `${v.value}%`
                                  : `${formatPrice(v.value / 1000)}k`}
                            </span>
                            <span className="text-[8px] sm:text-[10px] mt-0.5 sm:mt-1 font-bold uppercase">
                              {v.type === "gift" ? "GIFT" : "GIẢM"}
                            </span>
                          </div>

                          <div className="flex-1 min-w-0">
                            <p className="text-xs sm:text-sm font-black text-gray-900 dark:text-white truncate uppercase">
                              {v.type === "gift" ? v.giftName : v.code}
                            </p>
                            <p className="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 mt-0.5 line-clamp-1">
                              {v.type === "gift"
                                ? "Đổi lấy phần quà hấp dẫn"
                                : v.description || "Ưu đãi đơn hàng TaHa Shoes"}
                            </p>
                            <div className="flex flex-wrap items-center gap-2 mt-1.5 sm:mt-2">
                              <span className="text-[9px] sm:text-[10px] px-1.5 py-0.5 bg-gray-100 dark:bg-slate-800 rounded text-gray-600 dark:text-gray-400 font-medium">
                                Từ {formatPrice(v.minOrder)}₫
                              </span>
                              {/* Cảnh báo sắp hết hạn */}
                              {Math.ceil(
                                (new Date(v.expiryDate) - new Date()) /
                                  (1000 * 60 * 60 * 24),
                              ) <= 1 && (
                                <span className="text-[9px] sm:text-[10px] px-1.5 py-0.5 bg-orange-50 dark:bg-orange-900/20 rounded text-orange-600 dark:text-orange-400 font-bold animate-pulse">
                                  Sắp hết hạn (Còn &lt; 24h)
                                </span>
                              )}
                            </div>
                          </div>

                          <button
                            onClick={() => handleApplyVoucher(v)}
                            disabled={
                              !isEligible || appliedVoucher?._id === v._id
                            }
                            className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl text-[10px] sm:text-xs font-bold transition-all whitespace-nowrap ${
                              appliedVoucher?._id === v._id
                                ? "bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400"
                                : isEligible
                                  ? "bg-blue-600 text-white hover:bg-blue-700"
                                  : "bg-gray-100 dark:bg-slate-800 text-gray-400"
                            }`}
                          >
                            {appliedVoucher?._id === v._id
                              ? "Đã chọn"
                              : isEligible
                                ? "Dùng ngay"
                                : "K đủ đk"}
                          </button>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              <div className="p-4 bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-slate-800 text-center">
                <p className="text-gray-400 dark:text-gray-500 text-[10px]">
                  Áp dụng ưu đãi cao nhất cho đơn hàng của bạn
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CheckoutPage;
